import IMask from 'imask';

/**
 * Svelte action: use:imask={options}
 * - Dispatches `accept` and `complete` events with the IMask instance in event.detail
 * - Supports reactive `options` via the `update` hook
 *
 * @param {HTMLInputElement} node
 * @param {Object} options - IMask options, e.g. { mask: '(000) 000-0000' }
 */
export function imask(node, options = {}) {
    // Create the mask
    const mask = IMask(node, options);

    // Re-emit IMask events so you can listen with on:accept / on:complete
    const onAccept = () => {
        //console.table(mask);
        node.dispatchEvent(new CustomEvent('accept', { detail: mask }));
    };
    const onComplete = () => {
        node.dispatchEvent(new CustomEvent('complete', { detail: mask }));
    };

    mask.on('accept', onAccept);
    mask.on('complete', onComplete);

    return {
        // Called when the options object changes
        update(newOptions = {}) {
            // Update mask configuration
            mask.updateOptions(newOptions);
        },
        // Cleanup when the element is removed
        destroy() {
            mask.off('accept', onAccept);
            mask.off('complete', onComplete);
            mask.destroy();
            //console.log('mask destroyed')
        }
    };
}